export const HEADERS = [
  'HEADER.ID',
  'HEADER.NAME',
  'HEADER.RISKS',
  'HEADER.KYC.COMPLETED',
  'HEADER.CREATED',
];
